/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable react/require-default-props */
/* eslint-disable max-len */
/* eslint-disable react/no-unused-prop-types */

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import fetchStylistsBySalon from 'actions/stylist/fetchStylistsBySalon.action';
import TooltipForReceptionist from 'components/TooltipForReceptionist';
import IN from 'constants/in';
import { withTranslation } from 'providers/GILT.provider';
import logger from 'utils/logger.util';

import InputFieldContainer from 'onboarding/common/InputField';
import InputWithDropdownContainer from 'onboarding/common/InputWithDropdown';
import { getRoles } from 'onboarding/roles/actions';
import AddServiceWithRole from 'onboarding/services/AddServiceWithRole';

const L = logger('AddService');

class AddService extends React.Component {
  static defaultProps = {
    settingsLayout: false,
  };

  componentDidMount() {
    // TODO: possible multiple requests, if so, move to common parent
    this.props.getRoles(this.props.currentSalon.id);
  }

  onInputChange = (value) => void this.props.onServiceNameChange(value);
  onCategoryChange = (category) => void this.props.onCategoryChange(category);
  onPrincingChange = (value) => void this.props.onPrincingChange(value);

  render() {
    const {
      isNameSelected,
      onCategoryChangeInSettings,
      category,
      roles,
      settingsLayout,
      onRolePriceBlur,
      onRoleApplicationChange,
      quickSetupLayout,
      onRoleCheckboxChange,
      onRoleProcessingChange,
      onRolePriceChange,
      service,
      serviceId,
      currentSalon,
      categories,
      selectTemplate,
      addNewService,
      serviceTemplates,
      t,
    } = this.props;

    const serviceName = service && service.name;
    L.debug('render()', serviceId, serviceName, { service, roles, category, categories });

    // NOTE: parent has difficulty holding onto the service object, but the serviceId is correct
    // so, this possible workaround uses the fetched roles to find the proper service for the id
    // const service = L.debug('render()', 'service:', findService({ serviceId, roles }));

    return (
      <div data-bem="AddService" className="content auto-height  obs-edit-input cfix">
        {!isNameSelected && !quickSetupLayout && (
          <InputWithDropdownContainer
            data={{
              id: 'ServiceNameInput',
              label: t('composite.addService.serviceNameLabel'),
              type: 'text',
              placeholder: t('composite.addService.serviceNamePlaceholder'),
              inputValue: serviceName,
              inputMode: 'text',
            }}
            autoFocus
            templates={serviceTemplates}
            onNewClick={addNewService}
            onSelect={selectTemplate}
            onChangeHandler={this.onInputChange}
          />
        )}
        {isNameSelected && !quickSetupLayout && (
          <>
            <div className="cfix relative">
              <InputFieldContainer
                data={{
                  id: 'ServiceNameInput',
                  label: t('composite.addService.serviceNameLabel'),
                  type: 'text',
                  placeholder: t('composite.addService.serviceNamePlaceholder'),
                  inputValue: service ? serviceName : '',
                  inputMode: 'text',
                }}
                onChangeHandler={this.onInputChange}
              />
              <TooltipForReceptionist where={IN.serviceEdit} />
            </div>
          </>
        )}
        {isNameSelected && currentSalon.pricing_type !== 'service' && (
          <AddServiceWithRole
            serviceId={serviceId}
            service={service}
            categories={categories}
            selectedCategory={category}
            quickSetupLayout={quickSetupLayout}
            roles={roles}
            onCategoryChange={this.onCategoryChange}
            onCategoryChangeInSettings={onCategoryChangeInSettings}
            onCheckboxChange={onRoleCheckboxChange}
            onPriceChange={onRolePriceChange}
            onPriceBlur={onRolePriceBlur}
            onApplicationChange={onRoleApplicationChange}
            onProcessingChange={onRoleProcessingChange}
            onPrincingChange={this.onPrincingChange}
            settingsLayout={settingsLayout}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state.onboarding.roles,
  currentSalon: state.currentSalon,
  categories: state.onboarding.services.categories,
  isSaved: state.onboarding.services.isSaved,
});

export const mapDispatchToProps = (dispatch) => bindActionCreators({ getRoles, fetchStylistsBySalon }, dispatch);

const AddServiceHoc = connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AddService));

export default AddServiceHoc;
